import { render, staticRenderFns } from "./Letter.vue?vue&type=template&id=0687bc60&scoped=true&"
import script from "./Letter.vue?vue&type=script&lang=js&"
export * from "./Letter.vue?vue&type=script&lang=js&"
import style0 from "./Letter.vue?vue&type=style&index=0&id=0687bc60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0687bc60",
  null
  
)

export default component.exports